import React from 'react';
import { useTranslation } from 'react-i18next';
import { Progress } from '@/components/ui/progress';
import UploadCard from './UploadCard';

interface UploadProgressCardProps {
  progress: number;
  currentFile: string;
}

const UploadProgressCard: React.FC<UploadProgressCardProps> = ({ progress, currentFile }) => {
  const { t } = useTranslation();

  return (
    <UploadCard title={t('testUpload.uploading')}>
      <Progress value={progress} />
      <p className="revy-cjk revy-figure mt-2 text-sm leading-[1.6] text-muted-foreground">
        {progress.toFixed(1)}% - {currentFile}
      </p>
    </UploadCard>
  );
};

export default UploadProgressCard;
